export enum StateStatuses {
  FAILED = "FAILED",
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  CREATING = "CREATING",
  SEARCHING = "SEARCHING",
  PROCESSING = "PROCESSING",
}
